define([
	"dojo/_base/declare",
	"csi",
	"csi/_base/underscore",
	"csi/action/Controller",
	"csi/sessionConstants",
	"csi/xml"
], function(declare, csi, _, Controller, sessionConstants, xml) {

	return declare(Controller, {
		process: function() {
			// NOTE: assumption is that custom view is not dirty when this happens
			const cv = this.widget.getSelectedCustomView();
			let parties;
			const currentUserUrl = sessionConstants.userUrl;
			// FIX: need to remove as default from previous party
			const urlOldParties = cv.getParty();
			const urlNewParty = this.getAction().shareWith;

			if (urlNewParty === currentUserUrl) {
				parties = [currentUserUrl];
			} else if (urlNewParty === csi.EMPTY_URL) {
				parties = [];
			} else if (cv.isSharedWithRole(urlNewParty)) {
				parties = _.without(urlOldParties, urlNewParty);
			} else {
				parties = urlOldParties.concat(urlNewParty);
			}

			cv.values.prefParty = parties;

			this.m_urlNode = cv.urlNode;

			this.inherited(arguments);
		},

		toWriter: function() {
			// summary: set UMEntry attribute
			var cv = this.widget.getSelectedCustomView();
			var parties = cv.getParty();
			this.m_writer.changeNode(this.m_urlNode).changeAttribute("UMEntry", xml.ATTR_REFLIST, parties);

			// no need to return results
			this.m_writer.noReturnNodes();
		},

		postProcessSuccess: function() {
			// summary: notify view that available custom view
			this.widget.onChangeDefaultCustomView();
		}
	});
});